import { useEffect, useImperativeHandle, useRef } from "react";

import persian_fa from "react-date-object/locales/persian_fa"
import calendar_persian from "react-date-object/calendars/persian"
import DatePicker, { DatePickerRef } from "react-multi-date-picker"


type reportListItems = {
  required: boolean;
  name: string;
  type: string;
  options: { values: any[]; };
  display_name: string;
}
export const DateInput = ({ item, index }: { item: reportListItems, index: number }) => {
  const ref = useRef<DatePickerRef>()
  useEffect(() => {
    console.log(item)

  }, [ref])
  const addNameToDateInput = () => {
    // useImperativeHandle(ref, () => ({
      
    // }))
  }
  return (
    <div key={'report_input_' + index} className="w-1/2 px-2 py-3">
      <div className='mb-2 text-xs'>{item.display_name}</div>
      <DatePicker
        ref={ref}
        locale={persian_fa}
        calendar={calendar_persian}
        calendarPosition="bottom-right"
        inputClass='p-2 w-full border rounded-md text-xs'
        containerClassName='w-full'
      />
    </div>
  )
}